import { LicenseMonthlyOwnBundleFormWebComponent } from './component/LicenseMonthlyOwnBundleFormWebComponent';
import { WEB_COMPONENT_LICENSE_MONTHLY_BUNDLE_FORM } from '../../../webcomponents.constants';

export { LicenseMonthlyOwnBundleFormWebComponent };

window.customElements.define(WEB_COMPONENT_LICENSE_MONTHLY_BUNDLE_FORM, LicenseMonthlyOwnBundleFormWebComponent);
